import type { DecisionRow, DecisionRowApprovalSnapshot, MyDecisionsDirectReportRow } from "../../types";
import type { IncreaseValues } from "../MyDecisions/types";

export const coerceBudgetIncreaseNumber = (v: number | "" | null | undefined): number => {
	if (v === "" || v === null || v === undefined) return 0;
	return typeof v === "number" && Number.isFinite(v) ? v : 0;
};

export const isDraftPercentMissing = (increaseValues: IncreaseValues, rowId: string): boolean => {
	const p = increaseValues[rowId]?.percent;
	return p === undefined || p === null || p === "";
};

export const isDraftAmountMissing = (increaseValues: IncreaseValues, rowId: string): boolean => {
	const a = increaseValues[rowId]?.amount;
	return a === undefined || a === null || a === "";
};

export const NOTES_MAX_LENGTH = 800;

/** Stable string for PATCH `notesByDecisionRowId` keys (direct-report `employee_id`) */
export const notesPayloadKey = (r: DecisionRow): string => String(r.employee_id ?? "");

const mapApprovalToSnapshot = (a: MyDecisionsDirectReportRow["approvals"][number]): DecisionRowApprovalSnapshot => ({
	approver_id: String(a.approverId),
	approver_name: a.approverName,
	sequence: a.sequence,
	status: a.status,
	decided_at: a.decidedAt != null ? String(a.decidedAt) : null,
	notes: a.notes ?? null,
	amount_at_approval: a.amountAtApproval,
	updated_at: a.updatedAt != null ? String(a.updatedAt) : null,
	proposed_increase_amount: a.proposedIncreaseAmount ?? null,
	proposed_increase_percent: a.proposedIncreasePercent ?? null,
	proposed_salary: a.proposedSalary ?? null,
});

export const toDecisionRow = (
	dr: MyDecisionsDirectReportRow,
	index: number,
	userID: string | undefined
): DecisionRow => {
	const approvalEntry =
		userID === undefined || dr.approvals.length === 0
			? null
			: (dr.approvals.find((a) => String(a.approverId) === userID) ?? null);

	const approvalEntries = dr.approvals.map(mapApprovalToSnapshot);

	return {
		_id: String(dr.id),
		compensation_cycle_id: String(dr.compensationCycle),
		employee_id: String(dr.employeeId),
		employee_name: dr.name || `Employee ${index + 1}`,
		employee_title: dr.jobTitle,
		employee_role: dr.role?.name ?? null,
		current_salary: dr.currentSalary,
		proposed_increase_percent: dr.proposedIncreasePercent,
		proposed_increase_amount: dr.proposedIncreaseAmount,
		proposed_salary: dr.proposedSalary,
		status: dr.status,
		notes: dr.myDecisionNotes ?? approvalEntry?.notes ?? null,
		approver: approvalEntry?.approverId != null ? String(approvalEntry.approverId) : null,
		updatedAt: dr.updatedAt ?? approvalEntry?.updatedAt ?? null,
		approval_entries: approvalEntries.length > 0 ? approvalEntries : undefined,
	};
};
